module.exports = __webpack_public_path__ + "img/two_single.dc583c3c.png";